import {FC} from 'react'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAppIntl} from '../../../i18n'

const Error404: FC = () => {
  const {formatMessage} = useAppIntl()

  return (
    <>
      <h1 className='fw-bolder fs-2hx text-gray-900 mb-4'>
        {formatMessage({id: 'common.error404.title'})}
      </h1>

      <div className='fw-semibold fs-6 text-gray-500 mb-7'>
        {formatMessage({id: 'common.error404.message'})}
      </div>

      <div className='mb-3'>
        <img
          src={toAbsoluteUrl('/media/auth/404-error.png')}
          className='mw-100 mh-300px theme-light-show'
          alt=''
        />
        <img
          src={toAbsoluteUrl('/media/auth/404-error-dark.png')}
          className='mw-100 mh-300px theme-dark-show'
          alt=''
        />
      </div>

      <div className='mb-0'>
        <Link to='/dashboard' className='btn btn-sm btn-primary'>
          {formatMessage({id: 'common.error404.returnHome'})}
        </Link>
      </div>
    </>
  )
}

export {Error404}
